<template>
    <div>
        <el-dialog
                :visible.sync="show"
                center
                :show-close="false"
                @close="close"
                width="620px">
            <div>

                <div slot="title" style="margin-bottom: 20px;">
                    <CustomDialogHeader
                        :title="popTitle"
                        @close="close"
                    />
                </div>

                <div class="sys-p">
                    <!-- <div class="sys-tips" v-if="type == 1">
                        更改系统封面内文字，请<span>联系客服</span>免费帮您制作好看的活动封面。
                    </div> -->

                    <div class="search-block">
                        <div class="search-wrapper">
                            <i class="search-icon el-icon-search"></i>
                            <input
                                v-model="tagName"
                                class="search-input-inner"
                                placeholder="输入场景如班级、会议、培训等"
                                @keyup.enter="handleSearch"
                            />
                            <button class="search-btn" @click="handleSearch">搜索</button>
                        </div>
                    </div>

                    <div class="types-block">
                        <span v-for="(item,index) in list1"
                              :key="index" @click="selectThis(index,item)" :class="{'active': index == selectIndex}">{{ item.name }}</span>
                    </div>

                    <div class="sys-pic-block">
                        <div class="sys-each" v-for="(item, index) in sysPicsArr" :key="index" @click="selectSysPic(item,index)" :class="{'sys-each-active': sysPicsArrIndex == index}">
<!--                            <img class="itemPic" :src="item.url" alt="">-->
                          <el-image lazy :src="item.url" fit="cover"></el-image>
                            <div class="sys-select-dom" v-if="sysPicsArrIndex == index">使用</div>
                        </div>
                        <div class="classify_empty"></div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="kfPopShow = true">联系客服</el-button>
                <el-button type="primary" v-if="type == 1" @click="sureSelect">确 定</el-button>
                <el-button type="primary" v-if="type == 2" @click="shareSelect">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
                title="联系客服"
                :visible.sync="kfPopShow"
                center
                @close="closeKfPop"
                :show-close="true"
                width="350px">
            <div style="text-align:center">
                <img class="kf-qr" v-show="appid == 'wx1e899bddb256a5ca'" src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-kf-jiajia-qr.png" alt="" />
                <img class="kf-qr" v-show="appid == 'wx7d8daf6d777947a2'" style="width: 190px; top: 8px" src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-kf-guanjia-qr.png" alt="" />
            </div>

        </el-dialog>
    </div>
</template>

<script>
    import CustomDialogHeader from '../CustomDialogHeader.vue'
    import copyrightConfig from '@/utils/config/changeCopyright.js'
    import { getimageUrls,getimageTypes } from '@/utils/api/activity'
    export default {
        name: "systemPictures",
        data(){
            return{
                appid: copyrightConfig.AppID,
                show: false,
                activityModeUrl: 'https://ossfastmake.xlkapp.com/12xtPictures/xt-1.svg',
                sysPicsArr: [],
                sysPicsArrIndex: 9999,
                type: 1,
                popTitle: '',
                kfPopShow: false,
                imageName: '',
                tagName: '',
                list1: [],
                selectIndex: 0,
            }
        },
        mounted() {
            this._getimageTypes()
            this.getSysPics()
        },
        components: { CustomDialogHeader },
        methods: {
            selectThis(idx,info){
                this.selectIndex = idx;
                this.imageName = info.name;
                if (idx == 0){
                    this.imageName = '';
                }
                this.getSysPics()
            },
            closeKfPop(){
                this.kfPopShow = false;
            },
            open() {
                this.sysPicsArrIndex = 9999;
            },
            openSysPop(type) {
                this.type = type;
                if (type == 1){
                    this.popTitle = '系统封面'
                }
                if (type == 2){
                    this.popTitle = '系统分享图'
                }
                this.show = true;
            },
            close() {
                this.show = false
            },
            handleSearch(){
                // 触发搜索事件，将 tagName 传递给父组件
                this.$emit('search', this.tagName)
                console.log('搜索关键词:', this.tagName)
            },
            contactCustomer(){
                // 调用父组件的customer方法
                this.$emit('customer')
            },
            async _getimageTypes(){
                let res = await getimageTypes()
                if (res.status == 1){
                    console.log(res,'封面类型')
                    this.list1 = res.data.map( item => {
                        return {
                            name: item.image_name
                        }
                    })
                    // 向数组list1最前面插入{name: '常用'}
                    // this.list1.unshift({name: '常用'})
                    console.log(this.list1,'this.list1')
                }
            },
            async getSysPics(){
                const res = await getimageUrls({
                    imageName: this.imageName,
                    tagName: this.tagName
                })
                this.sysPicsArr = res.data;
            },
            selectSysPic(item,index){
                this.sysPicsArrIndex = index;
            },
            sureSelect(){
                if (this.sysPicsArrIndex == 9999){
                    // uni.showToast({
                    //     title: '请选择图片',
                    //     icon: 'none',
                    // })
                    return false;
                }
                this.close()
                this.$emit('sureSelect',this.sysPicsArr[this.sysPicsArrIndex].url);
            },
            shareSelect(){
                if (this.sysPicsArrIndex == 9999){
                    // uni.showToast({
                    //     title: '请选择图片',
                    //     icon: 'none',
                    // })
                    return false;
                }
                this.close()
                this.$emit('shareSelect',this.sysPicsArr[this.sysPicsArrIndex].url);
            },
        }
    }
</script>

<style scoped lang="scss">
::v-deep .el-dialog__header {
  padding: 0; // 移除内边距
}
    .sys-tips{
        color: #636A84;
        font-size: 15px;
        /*padding: 0px 40px 0;*/
        text-align: center;
        span{
            color: #1877FF;
        }
    }
    .search-block{
        width: 90%;
        margin: 5px auto;
    }
    .search-wrapper{
        display: flex;
        align-items: center;
        background: #fff;
        border: 1px solid #e0e0e0;
        border-radius: 6px;
        padding: 0 15px;
        height: 40px;
        box-sizing: border-box;
        padding-right: 4px;
    }
    .search-icon{
        color: #999;
        font-size: 18px;
        margin-right: 10px;
    }
    .search-input-inner{
        flex: 1;
        border: none;
        outline: none;
        height: 100%;
        font-size: 14px;
    }
    .search-btn{
        background: #1877ff;
        color: #fff;
        border: none;
        border-radius: 6px;
        padding: 6px 15px;
        font-size: 14px;
        cursor: pointer;
        margin-left: 10px;
    }
    .search-btn:hover{
        background: #409EFF;
    }
    .sys-pic-block{
        width: 100%;
        height: 500px;
        /*display: flex;*/
        /*display: -webkit-flex;*/
        /*justify-content: space-between;*/
        /*flex-direction: row;*/
        /*flex-wrap: wrap;*/
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 20px;
        box-sizing: border-box;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .sys-btns{
        padding: 40px;
    }
    .sys-btns .lxkf{
        width: 480px;
        height: 160px;
        background: #ffffff;
        border: 1px solid #1877ff;
        border-radius: 80px;
        color: #1877ff;
        font-size: 15px;
        font-weight: bold;
    }
    .sys-btns .sure{
        width: 760px;
        height: 160px;
        background: #1877ff;
        border: 1px solid #1877ff;
        border-radius: 80px;
        color: #fff;
        font-size: 15px;
        font-weight: bold;
    }
    .sys-each{
        width: 150px;
        height: 120px;
        margin: 10px;
        position: relative;
        float: left;

    .itemPic{
        width: 100%;
        height: 100%;
        border: 1px solid #fff;
    }
    .sys-select{
        width: 50px;
        height: 50px;
        position: absolute;
        right: 0;
        bottom: 0;
    }
    }
    .classify_empty{
        width: 600px;
        height: 0px;
        margin: 20px;
    }
    .sys-each-active .itemPic{
        border: 1px solid #1877ff;
    }
    .kf-qr{
        width: 200px;
        height: auto;
    }
    .sys-select-dom{
        width: 44px;
        height: 26px;
        font-size: 15rpx;
        position: absolute;
        right: 0;
        bottom: 0px;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        border-top-left-radius: 15px;
        background: linear-gradient(to right, #5356FF, #843FFF);
    }
    .types-block{
        width: 90%;
        margin: 0 auto;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
    }
    .types-block span{
        display: inline-block;
        padding: 10px;
        position: relative;
        font-weight: bold;
        color: #798497;
        cursor: pointer;
    }
    .types-block span.active{
        color: #323B5A;
    }
         .types-block .active:after{
         content: '';
         width: 15px;
         height: 4px;
         border-radius: 2px;
         background-color: #1877ff;
         position: absolute;
         bottom: 0;
         left: 15px;
     }

     .custom-title {
        //  padding: 20px 20px 0 20px;
        //  border-bottom: 1px solid #e4e7ed;
         margin-bottom: 20px;
     }
    ::v-deep .el-dialog--center .el-dialog__body{
        padding: 5px 25px 30px;
    }
</style>
